import { render, staticRenderFns } from "./CmgFooter.vue?vue&type=template&id=dc906cb0&scoped=true&lang=pug&"
import script from "./cmg-footer.ts?vue&type=script&lang=ts&"
export * from "./cmg-footer.ts?vue&type=script&lang=ts&"
import style0 from "./CmgFooter.vue?vue&type=style&index=0&id=dc906cb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc906cb0",
  null
  
)

export default component.exports